"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_styles_1 = require("./styled.styles");
const helpers_1 = require("../../helpers");
const EnhancedCheckbox = ({ children, onChange, checked, setChecked, }) => {
    (0, react_1.useEffect)(() => { }, []);
    return ((0, jsx_runtime_1.jsx)(styled_styles_1.CheckBoxLabel, Object.assign({ onClick: () => {
            setChecked(!checked);
            onChange && onChange(!checked);
        }, "data-checkbox-label": "true" }, (0, helpers_1.classNames)("relative inline vMiddle pointer noSelection", checked && "checked"), { children: children })));
};
exports.default = EnhancedCheckbox;
